/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Guides_Formulas_DescriptionInputs */

const en_gc_guides_formulas_description = /** @type {(inputs: Gc_Guides_Formulas_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Practice SUM and IF in the GridCraft ArtCraft spreadsheet editor. Follow a simple example, change the inputs and verify the calculated results.`)
};

const zh_gc_guides_formulas_description = /** @type {(inputs: Gc_Guides_Formulas_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在 GridCraft ArtCraft 电子表格编辑器中练习 SUM 和 IF，跟随示例修改输入并核对计算结果。`)
};

/**
* | output |
* | --- |
* | "Practice SUM and IF in the GridCraft ArtCraft spreadsheet editor. Follow a simple example, change the inputs and verify the calculated results." |
*
* @param {Gc_Guides_Formulas_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_guides_formulas_description = /** @type {((inputs?: Gc_Guides_Formulas_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Guides_Formulas_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_guides_formulas_description(inputs)
	return zh_gc_guides_formulas_description(inputs)
});
export { gc_guides_formulas_description as "gc.guides.formulas.description" }